import { throttle } from '@/utils'
// import resume from '@/views/resume/components/option'

var myMixin = {
  data() {
    return {
    //   info: resume.online.con
    }
  },
  watch: {
    info: {
      handler(n) {
        this.handleSave(n)
      },
      deep: true
    }
  },
  created() {
  },
  methods: {
    handleSave(n) {
    //   let form = window.localStorage.getItem('jin-resume-from') ? JSON.parse(window.localStorage.getItem('jin-resume-from')) : {}
      throttle(() => {
        // form = { ...form, ...n }
      }, 1000)
    }
  }
}

export {
  myMixin
}

